import React from "react";
import Typography from "../Typography";

import { LinksSocial as LinksSocialStyled } from "./styled";

import { ReactComponent as VkIcon } from "./socialIcons/social-button-vk.svg";
import { ReactComponent as TgIcon } from "./socialIcons/social-button-tg.svg";

export function LinksSocial() {
  return (
    <div>
      <Typography color="secondary" semibold>
        Подпишитесь на нас:
      </Typography>
      <LinksSocialStyled>
        <a
          href="https://m.vk.com/it_radio_wave"
          target="_blank"
          rel="noreferrer"
        >
          <VkIcon />
        </a>
        <a href="https://t.me/itradio_rostov" target="_blank" rel="noreferrer">
          <TgIcon />
        </a>
      </LinksSocialStyled>
    </div>
  );
}
